export default __webpack_public_path__ + "static/media/Ador_logo_cropped.e7370a83.png";